export enum EvaluationSocketEvents {
  GoogleCalendarEvent = 'googleCalendarEvent',
  PushEvalId = 'pushEvalId',
}
